module.exports = __webpack_public_path__ + "img/reference-aha-liechtenstein.eb359490.jpg";